import CryptoJS from "crypto-js";

const SECRET = process.env.REACT_APP_SECRET;

export const setSecure = (key, value) => {
  const encrypted = CryptoJS.AES.encrypt(
    JSON.stringify(value),
    SECRET
  ).toString();

  sessionStorage.setItem(key, encrypted);
};

export const getSecure = (key) => {
  const data = sessionStorage.getItem(key);

  if (!data) return null;

  const bytes = CryptoJS.AES.decrypt(data, SECRET);

  return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
};

export const removeSecure = (key) => {
  sessionStorage.removeItem(key);
};